"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgreementDetails = void 0;
const Base_1 = require("./Base");
exports.GetAgreementDetails = {
    url: Base_1.URL_BASE + "/GetAgreementDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetAgreementDetails.js.map